import React from 'react';
import { useSearchParams } from 'react-router-dom';
import {
  TeacherLoadingState,
  TeacherMedalListPage,
  TeacherPageShell,
  useTeacherAdventureOverview,
} from './teacherAdventureShared';

export const TeacherMedalsPage: React.FC = () => {
  const [searchParams] = useSearchParams();
  const selectedDate = searchParams.get('date') ?? undefined;
  const selectedLessonRunId = searchParams.get('lessonRunId') ?? undefined;
  const { overview, isLoading, loadError } = useTeacherAdventureOverview(selectedDate, selectedLessonRunId);

  if (isLoading || loadError) {
    return (
      <TeacherPageShell title="学生获得勋章" description="这里集中查看学生已经获得的勋章。">
        <TeacherLoadingState error={loadError} loadingText="正在加载学生勋章..." />
      </TeacherPageShell>
    );
  }

  return <TeacherMedalListPage records={overview.medalOverview} />;
};
